import obterCorDoStatusDaSolicitacao, {
  obterMensagemDoStatus,
  obterSetorDestinoDoStatus,
  obterSetorOrigemDoStatus,
  STATUS,
  statusEhDeErro,
} from '../../../../utils/statusDaSolicitacao';

const STATUS_DE_PRAZO_VENCIDO = [
  STATUS.PRAZO_DOSSIE_VENCIDO,
  STATUS.PRAZO_DOSSIE_VENCIDO_PRORROGACAO,
];

function obterVarianteDoPrazo(status) {
  if (STATUS_DE_PRAZO_VENCIDO.includes(status)) return 'vencido';
  if (status === STATUS.PRAZO_DOSSIE_PRORROGADO) return 'prorrogado';
  return null;
}

const STATUS_SEM_DESTAQUE_PRIMARIO = [
  STATUS.INCONFORME,
  STATUS.SUBSIDIO_LIQUIDADO,
  STATUS.INDEFERIDO,
];

function obterIcone(status, ehStatusDeErro, cor, varianteDoPrazo, ehSituacaoAtual) {
  if (status === STATUS.INCONFORME) return 'fa-solid fa-circle-exclamation';
  if (!ehSituacaoAtual) return 'fa-solid fa-circle-check';
  if (!STATUS_SEM_DESTAQUE_PRIMARIO.includes(status)) return 'fa-solid fa-circle';

  if (varianteDoPrazo === 'vencido') return 'fa-solid fa-triangle-exclamation';
  if (varianteDoPrazo === 'prorrogado') return 'far fa-clock';
  if (ehStatusDeErro) return 'fa-solid fa-circle-xmark';
  if (cor === 'Laranja') return 'fa-solid fa-circle-exclamation';
  return 'fa-solid fa-circle-check';
}

function obterCorDoMarcador(status, ehStatusDeErro, cor, varianteDoPrazo, ehSituacaoAtual) {
  if (status === STATUS.INCONFORME) return 'atencao';
  if (!ehSituacaoAtual) return 'sucesso';
  if (!STATUS_SEM_DESTAQUE_PRIMARIO.includes(status)) return 'primaria';

  if (varianteDoPrazo === 'vencido') return 'vinho';
  if (varianteDoPrazo === 'prorrogado') return 'info';
  if (ehStatusDeErro) return 'erro';
  if (cor === 'Laranja') return 'atencao';
  return 'sucesso';
}

function obterTextoEObservacao(item) {
  if (item.Justificativa) {
    return { texto: item.Justificativa, titulo: 'Justificativa' };
  }
  if (item.Observacao) {
    return { texto: item.Observacao, titulo: 'Observação' };
  }
  return { texto: null, titulo: null };
}

const STATUS_DE_REGISTRO_AUTOMATICO = [
  STATUS.PRAZO_DOSSIE_VENCIDO,
  STATUS.PRAZO_DOSSIE_VENCIDO_PRORROGACAO,
];

const STATUS_SEM_SETOR_NO_STATUS_ATUAL = [
  STATUS.INDEFERIDO,
  STATUS.SUBSIDIO_LIQUIDADO,
  STATUS.PRAZO_DOSSIE_VENCIDO,
  STATUS.PRAZO_DOSSIE_PRORROGADO,
  STATUS.PRAZO_DOSSIE_VENCIDO_PRORROGACAO,
];

function obterSetorResponsavelAtual(item, ehSituacaoAtual) {
  if (!ehSituacaoAtual) return null;
  if (STATUS_SEM_SETOR_NO_STATUS_ATUAL.includes(item.Status)) return null;
  return obterSetorDestinoDoStatus(item.Status);
}

function obterResponsavel(item) {
  if (STATUS_DE_REGISTRO_AUTOMATICO.includes(item.Status)) {
    return 'Registro automático';
  }
  return item.Usuario ? item.Usuario.Nome : null;
}

function obterTimestamp(data) {
  const timestamp = data ? new Date(data).getTime() : NaN;
  return Number.isNaN(timestamp) ? -Infinity : timestamp;
}

function ordenarDoMaisRecenteParaOMaisAntigo(historicoDoStatus) {
  return [...historicoDoStatus].sort((a, b) => {
    const diferencaDeData = obterTimestamp(b.DataDoEvento) - obterTimestamp(a.DataDoEvento);
    if (diferencaDeData !== 0) return diferencaDeData;
    return (b.Id || 0) - (a.Id || 0);
  });
}

export default function mapearHistoricoDoStatusParaLinhaDoTempo(
  historicoDoStatus,
  informacoesDoPagamento,
  numeroDoProcesso,
  dataDocumental,
  prazoDoDossie,
) {
  return ordenarDoMaisRecenteParaOMaisAntigo(historicoDoStatus || []).map((item, index) => {
    const ehSituacaoAtual = index === 0;
    const ehStatusDeErro = statusEhDeErro(item.Status);
    const cor = obterCorDoStatusDaSolicitacao(item.Status);
    const varianteDoPrazo = obterVarianteDoPrazo(item.Status);
    const { texto: observacao, titulo: tituloDaObservacao } = obterTextoEObservacao(item);

    return {
      id: item.Id,
      titulo: item.DescricaoDoStatus,
      corDaTag: `tags_cor-${cor.toLowerCase()}`,
      data: item.DataDoEvento,
      icone: obterIcone(item.Status, ehStatusDeErro, cor, varianteDoPrazo, ehSituacaoAtual),
      corDoMarcador: obterCorDoMarcador(
        item.Status,
        ehStatusDeErro,
        cor,
        varianteDoPrazo,
        ehSituacaoAtual,
      ),
      varianteDoPrazo,
      ehSituacaoAtual,
      setorResponsavelAtual: obterSetorResponsavelAtual(item, ehSituacaoAtual),
      mensagem: obterMensagemDoStatus(
        item.Status,
        informacoesDoPagamento,
        numeroDoProcesso,
        dataDocumental,
        prazoDoDossie,
      ),
      observacao,
      tituloDaObservacao,
      responsavel: obterResponsavel(item),
      setorOrigem: obterSetorOrigemDoStatus(item.Status),
      setorDestino: obterSetorDestinoDoStatus(item.Status),
    };
  });
}



// WEBPACK FOOTER //
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/utils/mapearHistoricoDoStatusParaLinhaDoTempo.js